import React, {FunctionComponent} from "react";
import {ArticleImage} from "./articleImage";
import {trimString} from "@klear/open-site/interfaces";

const styles = require('./article.component.scss');

const bigArticleExcerptLength = 120;
const smallArticleExcerptLength = 100;

interface ArticleLayoutProps {
    mainArticleImage?: string,
    mainArticleTitle: string,
    mainArticleDescription: string,
    isSmall: boolean
    tag?: string
}

export const Article: FunctionComponent<ArticleLayoutProps> = ({mainArticleImage, mainArticleTitle, mainArticleDescription, isSmall, tag}) => {
    return (
        <>
            <div className={styles.container}>
                <div className={styles.imageHover}>
                    <ArticleImage image={mainArticleImage || ''} size={isSmall ? "small" : "big"} tag={tag}/>
                </div>
                <div className={styles.imageHover}>
                    <ArticleImage image={mainArticleImage || ''} size={isSmall ? "small" : "big"} tag={tag}/>
                </div>
                {isSmall ?
                    <>
                        <div className={styles.articleTitle}>
                            <div dangerouslySetInnerHTML={{__html: mainArticleTitle}}/>
                        </div>
                        <div className={styles.articleDescription}>
                            <div dangerouslySetInnerHTML={{__html: trimString(mainArticleDescription,smallArticleExcerptLength)}}/>
                        </div>
                    </>
                    :
                    <div className={styles.articleTexts}>
                        <div className={styles.articleTitle}>
                            <div dangerouslySetInnerHTML={{__html: mainArticleTitle}}/>
                        </div>
                        <div className={styles.articleDescription}>
                            <div dangerouslySetInnerHTML={{__html: trimString(mainArticleDescription,bigArticleExcerptLength)}}/>
                        </div>
                    </div>
                }
                <div className={styles.selectedArrow}>
                    <div className={styles.goToPostText}>
                        Go To Article
                    </div>
                    <div className={styles.goToPostIcon}>
                        <i className="fa fa-arrow-right"/>
                    </div>
                </div>
            </div>
        </>
    )
}
